//@flow
import {withProps} from 'react-recompose';
import SuspendSwapTerminateSuccess from './SuspendSwapTerminateSuccess.container';
import theme from '../../theme-config';
import I18n from '../../lib/i18n';

import type {StateProps} from '../../components/SuccessPage/SuccessPage';
import type {StateType} from '../../modules/reducers';

const withSwapActivateProps = (state: StateType): StateProps => ({
  successImage: theme.swapSimImage,
  successTitle: I18n.t('SignUp.SwapSim.activate.successTitle'),
  successEsimTitle: I18n.t('SignUp.SwapSim.activate.successEsimTitle'),
  confirmButtonText: I18n.t('SignUp.SwapSim.successButton'),
  installEsimButtonText: I18n.t('SignUp.SwapSim.installEsim'),
  withGradient: true,
});

export default withProps(withSwapActivateProps)(SuspendSwapTerminateSuccess);
